import { render, staticRenderFns } from "./GtComment.vue?vue&type=template&id=3446712b&"
import script from "./GtComment.vue?vue&type=script&lang=ts&"
export * from "./GtComment.vue?vue&type=script&lang=ts&"
import style0 from "./GtComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports